const IS_VACATION_MODE = false;

export function useVacationMode() {
  if (!IS_VACATION_MODE) {
    return false;
  }

  const params = new URLSearchParams(window.location.search);
  const vmParam = params.get("vm");
  const localStorageKey = "vacation-mode-override";

  if (vmParam) {
    localStorage.setItem(localStorageKey, vmParam);
  }

  const storedVmParam = localStorage.getItem(localStorageKey);
  if (storedVmParam?.startsWith("20259")) {
    return false;
  }

  return true;
}
